
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-ten/dish-washer",
      function () {
        return require("private-next-pages/top-ten/dish-washer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-ten/dish-washer"])
      });
    }
  